import React, {useState} from "react";
import FirstSection from "./FirstSection";
import SecondSection from "./SecondSection";
import Footer from "./Footer";
import ThirdSection from "./ThirdSection";
import FourthSection from "./FourthSection";
import FifthSection from "./FifthSection";
import SixthSection from "./SixthSection";
import Icosahedronbg from "./Icosahedron";
import Pointer from "./pointer/Pointer";
import PseudoFirstSection from "./PseudoFirstSection";

import { AnimatePresence, motion} from "framer-motion";

const Main = () => {

  const [show, setShow] = useState(false);

  return (
    <div className="main">
      
      <Icosahedronbg />
      
      <div className="example">
      <div className="controls">
        <motion.button
          whileTap={{ scale: 0.2, transition: { duration: 1 } }}
          onClick={() => {
            setShow(!show);
          }}
        >
          {show ? "Switch OFF" : "Switch ON"}
        </motion.button>
      </div>

      <AnimatePresence>
        {/* {show ? <FirstSection /> : <FirstSection opacity="0" />} */}
        {show ? <FirstSection style= {show ? 'slide-in' : 'slide-out'} /> : <PseudoFirstSection />}
      </AnimatePresence>
    </div>

      
       <Pointer />
      <hr />

      <SecondSection />
      <hr />
      <ThirdSection />
      <hr />
       <FourthSection />
      <hr />
      <FifthSection />
      <hr />
      <SixthSection />
      <Footer />
    </div>
  );
};

export default Main;
